import { Client, QueryParameters } from 'algoliasearch';

export interface AlgoliaQuery {
  indexName?: string;
  query: string;
  params: QueryParameters;
}

type AlgoliaInitializer = () => Promise<{ index: string; client: Client }>;

export default function createAlgoliaService(initializer: AlgoliaInitializer) {
  return {
    async searchListings(params: AlgoliaQuery[]) {
      return initializer().then(({ client, index }) =>
        client.search(params.map(param => ({ ...param, indexName: index }))),
      );
    },
  };
}
